
export default {
    name: 'Transcriptions',
    data: () => {
        return {
            activeWords: undefined,
            inactiveWords: undefined,
        };
    },
    props: {
        currentTime: undefined,
        transcript: undefined,
    },
    computed: {
        getInactiveWords() {
            return this.inactiveWords;
        },
        getActiveWords() {
            return this.activeWords;
        },
    },
    watch: {
        currentTime() {
            this.buildTranscription();
        },
        transcript() {
            this.buildTranscription();
        },
    },
    methods: {
        buildTranscription() {
            var activeWords = '';
            var inactiveWords = '';
            let segmentStart = Math.floor(this.currentTime / 4) * 4;
            let segmentEnd = Math.ceil(this.currentTime / 4) * 4;

            var inCurrentSegment = false;
            var inInactiveSegment = false;
            for (var i = 0; i < this.transcript.words.length; i++) {
                let word = this.transcript.words[i];

                if (word.timeStart) {
                    if (word.timeStart >= segmentStart) {
                        inCurrentSegment = true;
                    } else {
                        continue;
                    }
                }

                if (word.timeStart >= segmentEnd) {
                    break;
                }

                if (word.timeStart > this.currentTime) {
                    inInactiveSegment = true;
                }

                if (!inCurrentSegment) {
                    continue;
                }

                // make first character of the whole transcript uppercase
                var wordContent = word.content;
                if (i === 0) {
                    wordContent = wordContent[0].toUpperCase() + wordContent.substring(1);
                }

                if (inInactiveSegment) {
                    if (inactiveWords != '' && word.timeStart && word.timeEnd) {
                        inactiveWords += ' ';
                    }
                    inactiveWords += wordContent;
                } else {
                    if (activeWords != '' && word.timeStart && word.timeEnd) {
                        activeWords += ' ';
                    }
                    activeWords += wordContent;
                }
            }

            this.activeWords = activeWords;
            this.inactiveWords = inactiveWords;
        },
    },
};
